export enum DataWizardUploadSitesApiStatus {
  Pending = 1,
  Failed = 3,
  ReadyToSave = 6,
  Saving = 9,
  Completed = 11,
  Cancelled = 15,
}
